/*
 * LEGACY - Background MP4 video controls
 */

window.addEventListener('DOMContentLoaded', () => {
	const allBackgroundVideos = document.querySelectorAll('.is-style-bg-video-controls video');

	if (allBackgroundVideos.length > 0) {
		const viewportWidth = window.innerWidth;
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		allBackgroundVideos.forEach((videoMP4) => {
			const videoFigure = videoMP4.parentElement;

			// If the video is set to autoplay, add the .playing class to the figure
			if (videoMP4.autoplay) {
				videoFigure.classList.add('playing');
			}

			// Change the play/pause state on click
			videoFigure.addEventListener('click', () => {
				if (videoMP4.paused === true) {
					videoMP4.play();
					videoFigure.classList.add('playing');
					videoFigure.classList.remove('paused');
				} else {
					videoMP4.pause();
					videoFigure.classList.remove('playing');
					videoFigure.classList.add('paused');
				}
			});

			// Don't autoplay for mobile or if the user has reduced motion enabled
			if (viewportWidth >= 782 && !mediaQuery.matches) {
				const videoObserver = new IntersectionObserver(
					([videoElem]) => {
						if (videoElem.isIntersecting) {
							videoMP4.play();
							videoFigure.classList.add('playing');
							videoObserver.unobserve(videoElem.target);
						}
					},
					{
						threshold: 0.2,
					}
				);

				videoObserver.observe(videoMP4);
			}
		});
	}
});
